import Cookies from 'js-cookie';

import { getTrackingGlobals } from '../globals';
import { integrationsToDisplayName } from '../tracking/integrations';
import { integrations } from '../tracking/integrations';
import trackingV3 from '../tracking/v3.exec';
import trackingV4 from '../tracking/v4.calls';
import { isV3, isV4 } from '../tracking-version';

const middleware = (payload: any, integrationName: string, next: (payload: any) => void) => {
    if (integrationName !== integrationsToDisplayName[integrations.facebookPixel]) {
        return next(payload);
    }

    if (!payload.obj.event) {
        return next(payload);
    }

    const nested = {
        ...JSON.parse(JSON.stringify(payload.obj)),
        fbp: Cookies.get('_fbp'),
        fbc: Cookies.get('_fbc'),
        userTraits: window.analytics?.user?.()?.traits() ?? {},
    };

    const facebookApiEventName = 'facebook-api';

    if (isV3()) {
        const data = {
            // need to set globals here because tracking v3 will scan through properties for
            // perspective data like campaignId, companyId, etc.
            ...getTrackingGlobals(),
            nested,
        };
        trackingV3.track(facebookApiEventName, data);
    } else if (isV4()) {
        const data = { nested };
        // context is set in the .track() call which used by tracking-v4 data-pipeline
        trackingV4.track(facebookApiEventName, data, {
            integrations: {
                All: false,
                Perspective: true,
            },
        });
    }
    return next(payload);
};

export default middleware;
